module.exports = __webpack_public_path__ + "img/15.683364eb.jpg";